import routerOptions0 from "/home/vsts/work/1/s/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/home/vsts/work/1/s/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}